module.exports = __webpack_public_path__ + "img/wzggc.d911c186.png";